import { render } from "./MedicalInterview.vue?vue&type=template&id=7313a1c5&scoped=true"
import script from "./MedicalInterview.vue?vue&type=script&lang=js"
export * from "./MedicalInterview.vue?vue&type=script&lang=js"

import "./MedicalInterview.vue?vue&type=style&index=0&id=7313a1c5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7313a1c5"]])

export default __exports__